import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Autocomplete,
} from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
const apiUrl = process.env.REACT_APP_API_URL;

const StallionForm = () => {
  const [isInHouse, setIsInHouse] = useState(true);
  const { t } = useTranslation();

  const [stallions, setStallions] = useState([]);
  const [formData, setFormData] = useState({
    horse_id: null,
    name: '',
    name_ar: '',
    origin_country: '',
    owner_id: '',
    notes: '',
  });

  useEffect(() => {
    axios
      .get(`${apiUrl}/stallions`)
      .then((res) => {
        const modifiedData = res.data.map((stallion) => ({
          horse_id: stallion.horse_id,
          name: stallion.name,
          name_ar: stallion.name_ar,
          origin_country: stallion.origin_country, // لاحظ الحقل المعدل
          owner_id: stallion.owner_id,
        }));
        setStallions(modifiedData);
      })
      .catch((err) => console.error('Error fetching stallions:', err));
  }, []);

  const handleInHouseChange = (e, value) => {
    setIsInHouse(value);
    setFormData({
      horse_id: null,
      name: '',
      name_ar: '',
      origin_country: '',
      owner_id: '',
      notes: '',
    });
  };

  const handleStallionSelect = (event, stallion) => {
    if (stallion) {
      setFormData({
        horse_id: stallion.horse_id,
        name: stallion.name,
        name_ar: stallion.name_ar,
        origin_country: stallion.origin_country,
        owner_id: stallion.owner_id,
        notes: '',
      });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // التحقق من القيم المطلوبة
    if (
      !formData.name ||
      !formData.name_ar ||
      !formData.origin_country ||
      (isInHouse && !formData.owner_id)
    ) {
      alert(t('يرجى تعبئة جميع الحقول الإلزامية'));
      return;
    }

    const payload = {
      name: formData.name,
      name_ar: formData.name_ar,
      origin_country: formData.origin_country,
      is_inhouse: isInHouse,
      notes: formData.notes,
      horse_id: isInHouse ? formData.horse_id : null,
      ...(isInHouse ? { owner_id: parseInt(formData.owner_id) } : {}), // ✅ فقط لو من الداخل
    };

    console.log('🚀 Sending payload:', payload);

    try {
      await axios.post(`${apiUrl}/stallions`, payload);
      alert(t('تمت العملية بنجاح'));
    } catch (error) {
      if (error.response?.status === 409) {
        alert(t('تم تسجيل هذا الخيل مسبقًا كفحل.'));
      } else {
        console.error('❌ Error inserting stallion:', error);
        alert(t('حدث خطأ، يرجى المحاولة مرة أخرى'));
      }
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ maxWidth: 600, margin: 'auto' }}
    >
      <FormControlLabel
        control={<Switch checked={isInHouse} onChange={handleInHouseChange} />}
        label={isInHouse ? t('stallion.inside') : t('stallion.outside')}
      />

      {isInHouse && (
        <Autocomplete
          options={stallions}
          getOptionLabel={(option) => option?.name || ''}
          onChange={handleStallionSelect}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('stallion.select')}
              margin="normal"
              required
            />
          )}
        />
      )}

      <TextField
        label={t('stallion.name_en')}
        name="name"
        value={formData.name || ''}
        onChange={handleChange}
        fullWidth
        required
        margin="normal"
      />
      <TextField
        label={t('stallion.name_ar')}
        name="name_ar"
        value={formData.name_ar || ''}
        onChange={handleChange}
        fullWidth
        required
        margin="normal"
      />
      <TextField
        label={t('stallion.country')}
        name="origin_country"
        value={formData.origin_country || ''}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      {isInHouse && (
        <TextField
          label={t('stallion.owner')}
          name="owner_id"
          value={formData.owner_id || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      )}

      <TextField
        label={t('stallion.notes')}
        name="notes"
        value={formData.notes || ''}
        onChange={handleChange}
        fullWidth
        multiline
        rows={4}
        margin="normal"
      />

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
      >
        {t('buttons.save')}
      </Button>
    </Box>
  );
};

export default StallionForm;
